import type { ReactNode } from "react";

type Props = {
  title?: ReactNode;
  // Right-aligned content in the title row (e.g. action button).
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function Card({ title, action, children, className }: Props) {
  return (
    <section
      className={
        "rounded-xl bg-white shadow-sm ring-1 ring-slate-200" +
        (className ? ` ${className}` : "")
      }
    >
      {title || action ? (
        <header className="flex items-center justify-between gap-4 border-b border-slate-200 px-5 py-3">
          {title ? (
            <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
          ) : (
            <span />
          )}
          {action ? <div>{action}</div> : null}
        </header>
      ) : null}
      <div className="px-5 py-4">{children}</div>
    </section>
  );
}
